import API from "./API";

export const getCategoryDataAPI = async (payload, hostname) => {
    try {
        const response = await API.get(`/seopages/categories`, { headers: payload });
        return response;
    }
    catch (error) {
        if (error?.response?.data?.message === "No value present") {
            return error?.response?.data;
        }
        throw error;
    }
};

export const getProspectiveCategoryDataAPI = async (payload, hostname) => {
    try {
        const response = await API.get(`/programmatic-pages/categories`, { headers: payload });
        return response;
    }
    catch (error) {
        if (error?.response?.data?.message === "No value present") {
            return error?.response?.data;
        }
        throw error;
    }
};